<template>
  <div>
    settings contacts
  </div>
</template>

<script>
export default {
  data: function () {
    return {}
  }
}
</script>

<style scoped>
</style>
